export default __webpack_public_path__ + "static/DemoBG-732c7dc6a60ace6f038d8cce8f933a63.svg";